import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import config from '@config'
import { useAppContext } from '@context/app'
import { getPluginPath, mergeChanges, PluginContextValue } from '@plugins/index'

const usePluginQuery = () => {
  const { retailerPartnerNumber, marketingCarrierCode } = useAppContext()

  const path = useMemo(
    () => getPluginPath(retailerPartnerNumber, marketingCarrierCode),
    [retailerPartnerNumber, marketingCarrierCode],
  )

  return useQuery<PluginContextValue>({
    queryKey: ['plugin', path],
    queryFn: async () => {
      const pluginsConfig = await import(`@plugins/Partners/${path}/index.ts`).then<Plugin.Config>(
        module => module.default,
      )
      const abTests = await Promise.all(
        Object.entries(config.abTests)
          .filter(([, matcher]) => matcher.rpns.includes(retailerPartnerNumber))
          .map(([path]) => import(`@abTests/${path}/index.ts`).then(module => module.default as Plugin.Config)),
      )

      return { ...mergeChanges(pluginsConfig, ...abTests), plugin: pluginsConfig, abTests }
    },
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: path != null,
  })
}

export default usePluginQuery
